const root = 'FiltersDrawerSection'

export const TestId = {
  backButton: `${root}-backButton`,
  searchInput: `${root}-searchInput`,
}
